export const COMPLETED = "COMPLETED";
